<template>
  <advice :color="`funds${funds.type}`">
    <v-layout row
              wrap>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.gift') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">
          {{funds.amountPrettyFormat}}
        </span>
      </v-flex>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.date') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">{{funds.dateCreated |
          formatDateMaxAvailabilityPark}}</span>
      </v-flex>
      <v-flex xs12
              sm4
              v-if="funds.company.id">
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.company') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">
          {{funds.company.name}}
        </span>
      </v-flex>
      <v-flex xs12
              sm4
              v-if="funds.coupon">
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.coupon') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">
          {{funds.coupon.code}}
        </span>
      </v-flex>
    </v-layout>
  </advice>
</template>

<script>
import Advice from '@/components/commons/Advice';

export default {
  name: 'FundsGift',
  props: ['funds'],
  components: {
    [Advice.name]: Advice
  },
  data() {
    return {};
  }
};
</script>
